import * as tslib_1 from "tslib";
import * as React from 'react';
import { FontIcon } from 'material-ui';
import { grey500, yellow600 } from 'material-ui/styles/colors';
var style = {
    cursor: 'pointer',
    marginRight: 0
};
var TaskRating = /** @class */ (function (_super) {
    tslib_1.__extends(TaskRating, _super);
    function TaskRating() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setValue = function (value) { return function (e) {
            e.preventDefault();
            _this.setState({ value: value }, function () { return _this.props.onChange(value); });
        }; };
        return _this;
    }
    TaskRating.prototype.render = function () {
        var stars = [];
        var value = this.props.value;
        for (var i = 0; i < this.props.max; i++) {
            var color = value > 0 && i + 1 <= value ? yellow600 : grey500;
            stars.push((React.createElement(FontIcon, { key: i, style: style, className: "material-icons", color: color, onClick: this.setValue(i + 1) }, "star_rate")));
        }
        return React.createElement("div", { title: "Ticket \u00E9rt\u00E9kel\u00E9se 1-5 k\u00F6z\u00F6tt \u00E1ll\u00EDthat\u00F3, 5 a legjobb \u00E9rt\u00E9kel\u00E9s." }, stars);
    };
    return TaskRating;
}(React.Component));
export default TaskRating;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskRating.tsx
// module id = 774
// module chunks = 0